// improve: handle milliseconds and publish?
// improve: consider returning as ISO 8061 duration
// improve: change to use milliseconds
// improve: getParts of timespan
// improve: wirte tests!
// question: could this be done functional style?
// https://speedysense.com/convert-float-to-time-in-javascript/#:~:text=floor(number)%3B%20var%20decpart,result%20sign%20%3D%20sign%20%3D%3D%201%20%3F
// improve: check valid TimeSpan strings with regex?
// regex to find valid timestring ^(-?[0-9]+\.)*[0-9]{2}:[0-9]{2}:[0-9]{2}$
// regex to find and validate ^(-?[0-9]+\.)*([01]?[0-9]|2[0-3]):[0-6][0-9]:[0-6][0-9]$
export class TimeSpan {
  constructor(
    days: number = 0,
    hours: number = 0,
    minutes: number = 0,
    seconds: number = 0,
    isNegativ: boolean = false
  ) {
    // improve: add for minutes, in a smart functional way?
    // improve: add decimal support for all parts?
    if (!Number.isInteger(hours)) {
      const hrs = Math.floor(hours);
      const dec = hours - hrs;
      const min = Math.round(dec / (1 / 60));

      this.setSeconds(seconds);
      this.setMinutes(min + minutes);
      this.setHours(hrs);
      this.setDays(days);
      return;
    }

    this.setFactor(isNegativ)
    this.setSeconds(seconds);
    this.setMinutes(minutes);
    this.setHours(hours);
    this.setDays(days);
  }

  private factor = 1;
  private days = 0;
  private hours = 0;
  private minutes = 0;
  private seconds = 0;

  // todo: harden with checks and allow without seconds?
  // handle milliseconds ("16:59:19.9633110")
  // as of right now, parse int just ignores the milliseconds and floats
  // could use unary coersion to convert to float
  static parse(timeString: string) {
    const defaultTime: TimeSpan = new TimeSpan(0,0,0,0,false)
    if (!timeString || typeof timeString !== 'string') {
      return defaultTime;
    }

    const tokens = timeString.split(":");
    const days = tokens[0].split(".");
    
    // add minutes if non exist
    if(!tokens[1]){
      tokens[1] = '00';
    }

    // add seconds if non exist
    if(!tokens[2]){
      tokens[2] = '00';
    }

    if (days.length === 2) {
      return new TimeSpan(
        parseInt(days[0], 10),
        parseInt(days[1], 10),
        parseInt(tokens[1], 10),
        parseInt(tokens[2], 10)
      );
    }

    return new TimeSpan(
      0,
      parseInt(tokens[0], 10),
      parseInt(tokens[1], 10),
      parseInt(tokens[2], 10),
      tokens[0].startsWith("-")
    );
  }

  static fromTimes(timeStrFrom: string, timeStrTo: string): TimeSpan {
    const from = TimeSpan.parse(timeStrFrom);
    const to = TimeSpan.parse(timeStrTo);
    return to.subtract(from);
  }

  static fromSeconds(seconds: number) {
    return new TimeSpan(0, 0, 0, seconds);
  }

  static fromTimeSpan(timeSpan: TimeSpan): TimeSpan {
    return new TimeSpan(
      timeSpan.getDays(),
      timeSpan.getHours(),
      timeSpan.getMinutes(),
      timeSpan.getSeconds()
    );
  }

  private setFactor(isNegativ : boolean = false){
    
    if(isNegativ){
      this.factor = -1
    }
    else{
      this.factor = 1
    }
  }

  private setSeconds(sec: number) {
    if (sec < 0) {
      sec *= -1;
      this.factor = -1;
    }

    this.seconds += sec;

    if (this.seconds > 59) {
      this.minutes += Math.floor(this.seconds / 60);
      this.seconds = this.seconds % 60;
    }
  }

  private setMinutes(min: number) {
    if (min < 0) {
      min *= -1;
      this.factor = -1;
    }

    this.minutes += min;

    if (this.minutes > 59) {
      this.setHours(Math.floor(this.minutes / 60));
      this.minutes = this.minutes % 60;
    }
  }

  private setHours(hours: number) {
    if (hours < 0) {
      hours *= -1;
      this.factor = -1;
    }

    this.hours += hours;

    if (this.hours > 23) {
      this.setDays(Math.floor(this.hours / 24));
      this.hours = this.hours % 24;
    }
  }

  private setDays(days: number) {
    if (days < 0) {
      days *= -1;
      this.factor = -1;
    }

    this.days += days;
  }

  // improve: implement as getters?
  getTotalSeconds(): number {
    return (
      (this.days * 24 * 60 * 60 +
        this.hours * 60 * 60 +
        this.minutes * 60 +
        this.seconds) *
      this.factor
    );
  }

  getDays(): number {
    return this.days * this.factor;
  }

  getHours(): number {
    return this.hours * this.factor;
  }

  getMinutes(): number {
    return this.minutes * this.factor;
  }

  getSeconds(): number {
    return this.seconds * this.factor;
  }

  getFactor(): number {
    return this.factor;
  }

  getTotalHours(): number {
    return (this.days * 24 + this.hours) * this.factor;
  }

  // improve: use milliseconds
  subtract(timeSpan: TimeSpan) {
    const diff = this.getTotalSeconds() - timeSpan.getTotalSeconds();
    return TimeSpan.fromSeconds(diff);
  }

  add(timeSpan: TimeSpan) {
    const totalSeconds = this.getTotalSeconds() + timeSpan.getTotalSeconds();
    const result = TimeSpan.fromSeconds(totalSeconds);
    return result;
  }

  reset() {
    this.factor = 1;
    this.days = 0;
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;

    return this;
  }

  /**
   * @returns TimeObject with days as hours
   */
  getAsTimeObject(): TimeObject {
    return {
      hours: (this.days * 24 + this.hours) * this.factor,
      minutes: this.minutes,
      seconds: this.seconds,
      factor: this.factor
    };
  }

  // improve: get as ISO 8601 duration string

  private pad(num: number) {
    return num < 10 ? `0${num}` : num;
    // return num.toString().padStart(2, "0");
  }

  toString() {
    return this.days
      ? `${this.factor === -1 ? "-" : ""}${this.pad(this.days)}.${this.pad(
          this.hours
        )}:${this.pad(this.minutes)}:${this.pad(this.seconds)}`
      : `${this.factor === -1 ? "-" : ""}${this.pad(this.hours)}:${this.pad(
          this.minutes
        )}:${this.pad(this.seconds)}`;
  }

  toStringShort() {
    return `${this.factor === -1 ? "-" : ""}${this.pad(
      this.days * 24 + this.hours
    )}:${this.pad(this.minutes)}`;
  }
}

// improve: should also contain days?
export interface TimeObject {
  hours: number;
  minutes: number;
  seconds: number;
  factor: number;
}

// const s = TimeSpan.fromTimes("14:32:00", "14:45:00");
// s;

// const sec = t.getTotalSeconds();
// sec;

// const b = new TimeSpan(0, 0, 25, 0);
// b;

// const d = t.subtract(b);
// d;

// const f = d.toStringShort();
// f

// const i = TimeSpan.parse("16:59:19.9633110");
// i;

// const u = new TimeSpan(0, 8.25, 15, 0);
// u;
